import { ChevronLeft } from 'lucide-react';
import styles from '../pages/ReviewCapturePage.module.css';

/**
 * Shown while the draft assembles in the background (see assembleDraft in
 * CaptureHappyPathFlow) — sets the expectation, before the patient ever sees
 * "Post to Google", that posting is a two-part hand-off: read/edit here, then
 * paste on Google's own screen. Previously this walkthrough only appeared
 * *after* the patient had already tapped a button that looked terminal
 * ("Post to Google"), which is what read as "done" and caused the drop-off.
 */
export function CaptureExpectationScreen({
  onContinue,
  onBack,
}: {
  onContinue: () => void;
  onBack: () => void;
}) {
  return (
    <div className={styles.card}>
      <div className={styles.question}>One more step after this</div>
      <p className={styles.sub}>
        Next you&apos;ll get your review to look over and edit. When you&apos;re ready to post it,
        we&apos;ll send you to Google — here&apos;s what that looks like once you&apos;re there:
      </p>
      <ol className={styles.postSteps}>
        <li className={styles.postStep}>
          <span className={styles.postStepNum}>1</span> Tap the stars ★★★★★
        </li>
        <li className={styles.postStep}>
          <span className={styles.postStepNum}>2</span> Press and hold inside the big text box
        </li>
        <li className={styles.postStep}>
          <span className={styles.postStepNum}>3</span> Tap <strong>Paste</strong>
        </li>
      </ol>
      <p className={styles.copiedHintAlert}>
        Your review isn&apos;t posted until you finish those steps on Google.
      </p>
      <button type="button" className={styles.btnPrimary} onClick={onContinue}>
        Got it — show me my review
      </button>
      <button type="button" className={styles.backBtn} onClick={onBack}>
        <ChevronLeft size={16} aria-hidden /> Back
      </button>
    </div>
  );
}
